/**
 * Morph Git SDK
 * 
 * Git operations for AI agents using Morph's backend infrastructure.
 * 
 * @example
 * ```typescript
 * import { MorphGit } from 'morphsdk/git';
 * 
 * const morphGit = new MorphGit({
 *   apiKey: process.env.MORPH_API_KEY!
 * });
 * 
 * // Initialize and push
 * await morphGit.init({ repoId: 'my-project', dir: './my-project' });
 * await morphGit.add({ dir: './my-project', filepath: 'src/app.ts' });
 * await morphGit.commit({ dir: './my-project', message: 'Update' });
 * await morphGit.push({ dir: './my-project', branch: 'main' });
 * ```
 */

export { MorphGit } from './client.js';
export type {
  MorphGitConfig,
  CloneOptions,
  PushOptions,
  PullOptions,
  AddOptions,
  CommitOptions,
  StatusOptions,
  LogOptions,
  CheckoutOptions,
  BranchOptions,
  DiffOptions,
  CommitObject,
  StatusResult,
  ChatMessage,
  CommitMetadata,
  MorphNotesSchema,
} from './types.js';

// Re-export isomorphic-git for advanced use cases
export { default as git } from 'isomorphic-git';
export { default as http } from 'isomorphic-git/http/node';

